import { TableFilterContextProvider } from 'features/TableFilter';
import { FC, memo } from 'react';
import { HistoryTable } from './HistoryTable';

export const HistoryPage: FC = memo(() => {
  return (
    <TableFilterContextProvider>
      <HistoryTable />
    </TableFilterContextProvider>
  );
});
